import { GraphicsFilterEnum } from "../domain/entities/DashboardEntity";
import { DashboardApiRepository } from "./DashboardApiRepository";

export const FIELD_LABELS: Record<GraphicsFilterEnum, string> = {
    [GraphicsFilterEnum.MACROACTIVO]: "Macroactivo",
    [GraphicsFilterEnum.SUBACTIVO]: "Subactivo",
    [GraphicsFilterEnum.MONEDA]: "Moneda",
    [GraphicsFilterEnum.PLAZO]: "Plazo",
    [GraphicsFilterEnum.CLASE_DE_INVERSION]: "Clase de inversión",
    [GraphicsFilterEnum.CALIFICACION]: "Calificación",
    [GraphicsFilterEnum.EMISOR]: "Emisor",
};

export const sensitivityMeasuresColumns = [
    { header: "Portafolio", accessor: "portfolio" },
    { header: "Nemotécnico", accessor: "mnemonic" },
    { header: "Tipo de instrumento", accessor: "instrumentType" },
    { header: "Instrumento", accessor: "instrument" },
    { header: "Moneda", accessor: "currency" },
    { header: "Tipo tasa facial", accessor: "facialRateType" },
    {
        header: "Tasa facial", accessor: "facialRate",
        render: (value: string | number) => {
            if (typeof value === "number")
                return new Intl.NumberFormat("es-ES", {
                    style: "percent",
                    minimumFractionDigits: 2,
                }).format(value);
            else
                return value;
        },
    },
    { header: "Modalidad", accessor: "mode" },
    { header: "Periodicidad", accessor: "periodicity" },
    { header: "Emisión", accessor: "emission" },
    { header: "Vemcimiento", accessor: "maturity" },
    {
        header: "Valoración moneda local",
        accessor: "localCurrencyValuation",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "Porcentaje", accessor: "percentage",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "percent",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "Duración", accessor: "duration",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "Duración modificada", accessor: "modifiedDuration",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "Convexidad", accessor: "convexity",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "DV01", accessor: "DV01",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
];

export const aggregatedByPortfoliosColumns = [
    { header: "Portafolio", accessor: "portfolio" },
    {
        header: "Valoración moneda local",
        accessor: "localCurrencyValuation",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "Duración", accessor: "duration",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "Duración modificada", accessor: "modifiedDuration",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "Convexidad", accessor: "convexity",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
    {
        header: "DV01", accessor: "DV01",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
];

export const dashboardGraphicsColumns = [
    { header: "Macroactivo", accessor: "macroactive" },
    { header: "Subactivo", accessor: "instrumentType" },
    { header: "Moneda", accessor: "currency" },
    { header: "Plazo", accessor: "rangleTerm" },
    { header: "Clase de inversión", accessor: "investmentClass" },
    { header: "Calificación", accessor: "rating" },
    { header: "Emisor", accessor: "issuerName" },
    {
        header: "Valoración moneda local",
        accessor: "localCurrencyValuation",
        render: (value: number) =>
            new Intl.NumberFormat("es-ES", {
                style: "decimal",
                minimumFractionDigits: 2,
            }).format(value),
    },
];

export const dashboardRepository = new DashboardApiRepository();

export const dashboardKeys = {
    all: ['futureFlow'] as const,
    allPortfolio: ['portfolio'] as const,
    allInstruments: ['instrument'] as const,
    allInstrumentTypes: ['instrumentType'] as const,
    allSensitivityMeasures: ['sensitivityMeasures'] as const,
    allDashboardGraphics: ['dashboardGraphics'] as const,
};